var Utils = require("common/Utils");

/**
 * @implements {AbstractView}
 * @constructor
 */
function AttributesListView() {
    var self = this;

    var $listview = $('<ul data-role="listview" data-theme="f" data-inset="false" id="attributesMenuContentList">');
    var $content = $("<div>").append($listview);

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "AttributesList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.show = function() {
        $content.show();
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::attributes.title"),
            i18n : "common::attributes.title"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    function renderCategories($listview, categories) {
        categories.forEach(function(category) {
            var title = "";

            if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
                title = $.t("common::" + category.title, {defaultValue : category.title});
            } else {
                title = category;
            }
            var $item = $("<li>").append($("<a>", {href : "#", text : title}));
            $item.on("click", (function(_key) {
                return function() {
                    self.publishEvent("AttributesController", "show-attributes-view", {category : _key});
                };
            })(category));
            $listview.append($item);
        });
    }

    this.setCategories = function(categories) {
        $listview.empty();

        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            var catMap = {};

            categories.forEach(function(cat) {
                if (catMap[cat.namespace] === undefined) {
                    catMap[cat.namespace] = [];
                }
                catMap[cat.namespace].push(cat);
            });

            var firstNamespace = true;
            Utils.iterateSorted(catMap, function(cats, namespace) {
                var $newListItem = $("<li>", {"class" : "namespace", text : $.t("common::attributes.namespace." + namespace)});
                if (!firstNamespace) {
                    $newListItem.prepend($("<div>", {"class" : "namespaceDivider"}));
                } else {
                    firstNamespace = false;
                }
                $listview.append($newListItem);
                renderCategories($listview, cats);
            }, true);
        } else {
            renderCategories($listview, categories);
        }

        if ($listview.hasClass("ui-listview")) {
            $listview.listview("refresh");
        }
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
    };
}

AttributesListView.prototype = require("../common/AbstractView");

module.exports = AttributesListView;


//////////////////
// WEBPACK FOOTER
// ./attributes/AttributesListView.js
// module id = 49
// module chunks = 0